import { ApiType } from "@gymflow/common";
import { ApiListResponse, FacilityDTO } from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { facilityAsPublicQueryKeys } from "./facilityAsPublicQueryKeys";

export async function facilityListAsPublicQueryFn({
  filter,
  api,
}: {
  filter?: Parameters<ApiType["public"]["facilityApi"]["find"]>[0];

  api: ApiType;
}) {
  return (await api.public.facilityApi.find({ ...filter }))
    .data as ApiListResponse<FacilityDTO>;
}

export function useQueryFacilityListAsPublic({
  api,
  opts,
}: {
  api: ApiType;
  opts?: Parameters<ApiType["public"]["facilityApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: facilityAsPublicQueryKeys.list(opts),
    queryFn: () => facilityListAsPublicQueryFn({ api, filter: opts }),
  });
}
